import React from 'react';
type Props = {
  label: string;
  className?: string;
  tone?: 'light' | 'dark';
};
export function SectionEyebrow({
  label,
  className = '',
  tone = 'light'
}: Props) {
  const text = tone === 'dark' ? 'text-cream/80' : 'text-ink/80';
  const box = tone === 'dark' ? 'bg-white' : 'bg-ink';
  return <p className={`flex items-center gap-3 font-accent text-[11px] uppercase tracking-[0.08em] ${text} ${className}`} data-id="element-409" data-mp="1nb4uvnescndr">
      <span aria-hidden="true" className={`inline-block h-[6px] w-[6px] shrink-0 ${box}`} data-id="element-410" data-mp="zn3p2m8zrl21" />
      {label}
    </p>;
}